// Interfaces
import { IbApiConfig } from './../interfaces/ib-api-config.interface';

/**
 * `ApiConfig` represents the configuration of the api.
 */
export class ApiConfig {
  /**
   * Url of api json.
   */
  public urlAPI: string;
  /**
   * Api version.
   */
  public version: number;
  /**
   * Current configuration.
   */
  public headers: any;

  /**
   * Creates a new `ApiConfig` instance.
   * @param config Initial configuration
   */
  constructor(config: IbApiConfig) {
    this.urlAPI = config.urlAPI || 'http://localhost:3000/';
    this.version = config.version;
    this.headers = config.headers || {};
  }

  /**
   * Returns current configuration of the api.
   * @returns Current configuration.
   */
  public getConfig(): IbApiConfig {
    return {
      urlAPI: this.urlAPI,
      version: this.version,
      headers: this.headers
    };
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/api/config/api-config.ts